import "@/businessLogicRegistry";
import { ConfigWrapper } from "@/components/ConfigWrapper";
import { ThemeProvider } from "@/context/ThemeContext";
import "@/i18n";
import "@/instrument";
import "@/styles/index.css";
// Public site design: must load after every Tailwind preflight (see site/styles/compat.css).
import "@jambushrushti/site/styles/index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <ConfigWrapper />
    </ThemeProvider>
  </StrictMode>
);
